import request from "./base";
const path = "/api/worker-analytics";

export default {
  get: function () {
    return request().get(path + "/");
  },
};
